<template>
	<Modal 
		title="DETALHES DA ENTREGA"
		breakpoint="lg"
		@close="close"
	>
		<div class="row">
			<div class="col-xs-12 col-lg-12 delivery-tab-container">
				<button class="delivery-tab" :class="{ 'enabled': (tab == 'detail') }" @click="tab = 'detail'">
					<i class="fas fa-fw fa-file"></i> Detalhes
				</button>
				<button class="delivery-tab" :class="{ 'enabled': (tab == 'item') }" @click="tab = 'item'">
					<i class="fas fa-fw fa-list"></i> Itens
				</button>
				<button v-if="true" class="delivery-tab" :class="{ 'enabled': (tab == 'payment') }" @click="tab = 'payment'">
					<i class="fas fa-fw fa-credit-card"></i> Pagamento
				</button>
				<button v-if="current_data.fk_delivery_observation" class="delivery-tab" :class="{ 'enabled': (tab == 'observation') }" @click="tab = 'observation'">
					<i class="fas fa-fw fa-info-circle"></i> Observação
				</button>
			</div>
		</div>
		<div v-if="tab == 'detail'">
			<DeliveryDetail
				:current="current_data"
				ref="details"
			/>
		</div>
		<div v-if="tab == 'item'">
			<DeliveryItem
				:current="current_data"
				ref="item"
			/>
		</div>
		<div v-if="tab == 'payment'">
			<DeliveryPayment
				:current="current_data"
				ref="payment"
			/>
		</div>
		<div v-if="tab == 'observation'">
			<DeliveryObservation
				:current="current_data"
				ref="observation"
			/>
		</div>
	</Modal>
</template>

<script>
import Modal from "@/components/Modal";
import DeliveryDetail from "./DeliveryDetail.vue";
import DeliveryItem from "./DeliveryItem.vue";
import DeliveryPayment from "./DeliveryPayment.vue";
import DeliveryObservation from "./DeliveryObservation.vue";

export default {
	name: "DeliveryData",
	
	props: {
		current_data: {
			type: Object,
			require: true,
		},
		current_tab: {
			type: String,
			require: false,
			default: "detail",
		},
	},

	components: {
		Modal,
		DeliveryDetail,
		DeliveryItem,
		DeliveryPayment,
		DeliveryObservation,
	},

	data: function() {
		return {
			data: this.current_data,
			tab: this.current_tab,
		};
	},

	methods: {
		close: function() {
			this.$emit("close");
		},
	}
}
</script>

<style scoped>
.delivery-tab {
	background: #eee;
	border: 1px solid #eee;
	border-bottom: none;
	padding: 10px 15px;
	margin-right: 5px;
	font-weight: bold;
    margin-bottom: -1px;
}
.delivery-tab.enabled {
	background: #fff;
}
.delivery-tab-container {
    border-bottom: 1px solid #eee;
}
.delivery-tab-block {
	display: none;
}
.delivery-tab-block.show {
	display: block;
}
</style>